<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/notice" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">通告栏</div>
        <div class="sub-title">普通用法</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>

        <div class="sub-title">滚动文字</div>
        <pre v-highlightjs="code2"><code class="html" ></code></pre>

        <div class="sub-title">显示右箭头</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>

        <div class="sub-title">可关闭</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-notice>央行近日下调存款利率</yu-notice>
      `,
      code2: `
  <yu-notice marquee>央行近日下调存款利率,以应对严峻的局势</yu-notice>
      `,
      code3: `
  <yu-notice arrow>央行近日下调存款利率</yu-notice>
      `,
      code4: `
  <yu-notice close>央行近日下调存款利率</yu-notice>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'icon',
          description: '图标class',
          types: 'String',
          default: 'icon-voice',
        },
        {
          prop: 'marquee',
          description: '是否滚动播出',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'close',
          description: '是否可关闭',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'arrow',
          description: '是否显示右箭头',
          types: 'Boolean',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'click',
          description: '点击通告栏时触发事件',
          callback: '无',
        },
        {
          event: 'close',
          description: '关闭通告栏时触发事件',
          callback: '无',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }
    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/notice.vue